/*
 * Copyright Evollis 2023
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import { TENANTS } from "../../../constants"

/* Utils */
import { loc } from "../../../core/utils"
import Bloc from "../../../digital-journey/ClientPage/components/Bloc"
import { getCivilStatuses } from "../../../digital-journey/ClientPage/service/ClientPageServices"
import Date from "../../../form/Date"
import RadiosField from "../../../form/RadiosField"
import TextField from "../../../form/TextField"
import InformationButton from "../../molecules/InformationButton"

/* Forms controls & validation */
import React from "react"
import { Col, Row } from "react-bootstrap"

export default function CompanyBlocBpls(props) {
  const { tunnelData, values, blocFields, completedFields } = props
  const { clientPageConfiguration, tenant } = tunnelData
  const { company } = clientPageConfiguration

  const getBlocTitleByTenant = () => {
    if (tenant === TENANTS.BPLS) return "firm_bloc_title"
    return "Company"
  }

  return (
    <Bloc
      hide={!company}
      name={getBlocTitleByTenant()}
      completedFields={completedFields}
      totalFieldsNumber={blocFields.length}
    >
      <div className="hard-shadow-white-block">
        <Row>
          <Col lg={12}>
            <TextField
              hidden={false}
              name="company.name"
              label={loc`Company name`}
              trimOnBlur={true}
              disabled={
                tunnelData.data.order.simplifiedJourneyEnabled &&
                !tunnelData?.simplifiedJourneyInputConfiguration?.company?.name.editable
              }
            />
          </Col>
          <Col lg={12}>
            <TextField
              hidden={false}
              name="company.siret"
              label={loc`Company siret`}
              trimOnBlur={true}
              disabled={
                tunnelData.data.order.simplifiedJourneyEnabled &&
                !tunnelData?.simplifiedJourneyInputConfiguration?.company?.siret.editable
              }
            >
              <InformationButton overlayText={loc("Company siret infos")} />
            </TextField>
          </Col>
          <Col lg={12}>
            <div className="title-signatory">
              <RadiosField
                name={`company.executiveTitle`}
                checked={values.company.executiveTitle}
                items={getCivilStatuses(tunnelData)}
                label={loc`Title`}
                disabled={false}
              >
                <InformationButton placement="right" overlayText={loc("Executive civility tooltip")} />
              </RadiosField>
            </div>
          </Col>
          <Col lg={12}>
            <TextField
              hidden={false}
              name="company.executiveLastname"
              label={loc`Executive lastname`}
              trimOnBlur={true}
              disabled={
                tunnelData.data.order.simplifiedJourneyEnabled &&
                !tunnelData?.simplifiedJourneyInputConfiguration?.company?.executiveLastname.editable
              }
            />
          </Col>
          <Col lg={12}>
            <TextField
              hidden={false}
              name="company.executiveFirstname"
              label={loc`Executive firstname`}
              trimOnBlur={true}
              disabled={
                tunnelData.data.order.simplifiedJourneyEnabled &&
                !tunnelData?.simplifiedJourneyInputConfiguration?.company?.executiveFirstname.editable
              }
            />
          </Col>
          <Col lg={8}>
            <Date
              hidden={false}
              name="company.executiveBirthdate"
              label={loc`Executive birthdate`}
              trimOnBlur={true}
              format={"DD/MM/YYYY"}
            />
          </Col>
        </Row>
      </div>
    </Bloc>
  )
}
